<template>
    <tailwind-layout title="Add Phone">
        <template #header>
            <div class="mb-4 px-4 sm:px-6 lg:px-8 mx-auto flex justify-between items-center">
                <h1 class="font-semibold text-2xl leading-tight">Add Phone</h1>
            </div>
        </template>
        <div class="overflow-hidden shadow-xl rounded-lg p-6 bg-white">
            <form @submit.prevent="store" class="space-y-8">
                <div class="space-y-8 border-b border-gray-200 pb-8">
                    <alert-card :type="'warning'">
                        <p>To complete the process of linking your RentRisk account to your bank account, we need to verify a few additional details to ensure everything is set up securely. One of the key steps in this process involves associating your account with a valid phone number.</p>
                        <br>
                        <p>Rest assured that your privacy and the security of your data are our top priorities. We follow strict privacy protocols, and your phone number will only be used for the purpose of verifying and securing your account.</p>
                    </alert-card>
                    
                    <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                        <div class="sm:col-span-2">
                            <label for="owner_name"
                                v-bind:class="(form.errors.owner_name) ? 'block text-sm font-medium text-red-500' : 'block text-sm font-medium text-gray-700'">
                                Phone <span class="text-red-700">*</span>
                            </label>
                            <div class="mt-1">
                                <input id="phone" v-model="form.phone" type="text"
                                    v-bind:class="(form.errors.phone) ? 'shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-red-300 rounded-md' : 'shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md'">
                                <p v-text="form.errors.phone" class="text-red-500 text-sm"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pt-5">
                    <div class="flex justify-end">
                        <inertia-link :href="route('rented-properties.index')"
                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Cancel</inertia-link>
                        <form-button :form="form" type="submit" class="ml-3">
                            Save
                        </form-button>
                    </div>
                </div>
            </form>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import SwitchGroup from "@/Shared/SwitchGroup.vue";
import RadioGroup from "@/Shared/RadioGroup.vue";
import AlertCard from '@/Shared/AlertCard.vue';
export default {
    props: {
        states: Object,
    },
    components: {
        TailwindLayout,
        FormButton,
        SelectInput,
        RadioGroup,
        AlertCard
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                phone: null,
            }),

        }
    },
    methods: {
        store() {
            this.form.post(this.route('users.save-phone'))
        },
    }
}
</script>
